import { getWardrobeItemsArgsToParams } from 'data/api/transformers/arguments/get-wardrobe-items-args-to-params'
import { GetWardrobeItemsArgs } from 'types/api/arguments/get-wardrobe-items-args'
import { GetWardrobeItemsResp } from 'types/api/response/get-wardrobe-items-resp'

import { api } from './api'
import { moneyObjectHeader } from './money-object-header'

export const getWardrobeItems = (args: GetWardrobeItemsArgs) =>
  api.get<GetWardrobeItemsResp>(`/wardrobe/${args.userId}/items`, {
    params: getWardrobeItemsArgsToParams(args),
    headers: moneyObjectHeader,
  })
